import React from 'react';

import styles from './WhyItMattersSection.module.scss';
import img from 'assets/images/about/team.png';

export default function WhyItMattersSection() {
  return (
    <section className={styles.whyItMattersSection}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.textBox}>
            <div className={styles.capture}>
              <span>Why It Matters</span>
            </div>
            <h2 className="corp-title">DIVERSITY & INCLUSION</h2>
            <div>
              <p>
                Diversity and Inclusion measures are critical factors in the
                future success of a company. We align these beliefs with
                actionable metrics that are reflected in the core makeup of our
                team.
              </p>
              <p>Our internal team is:</p>
              <ul>
                <li>Led by a Navy Veteran CEO</li>
                <li>58% Female Staff</li>
                <li>67% Minority Staff</li>
                <li>71% of our female staff are working mothers</li>
              </ul>
              <p>
                myBasePay is committed to tracking the data behind our external
                workforce to understand how diversity and inclusion efforts
                apply to the Contingent Worker population. As we look to become
                a resource for contract workers across the country, we aim to be
                at the forefront of showcasing the importance of a diversified
                flexible workforce.
              </p>
            </div>
          </div>
          <div className={styles.imgBox}>
            <img src={img} alt="target" />
          </div>
        </div>
      </div>
      <div className={styles.circle}></div>
    </section>
  );
}
